export default __webpack_public_path__ + "static/media/empty-state-element.05c2fb6c.png";